"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var sysTempApi = _interopRequireWildcard(require("@/api/systemMessageTemplate"));
var _editSystemTemp = _interopRequireDefault(require("./editSystemTemp.vue"));
var _permission = require("@/utils/permission");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    EditSystemTemp: _editSystemTemp.default
  },
  data: function data() {
    return {
      constants: this.$constants,
      listPram: {
        page: 1,
        limit: this.$constants.page.limit[0],
        templateKey: '',
        templateName: '',
        status: null
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: false
    };
  },
  mounted: function mounted() {
    this.handlerGetListData();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    resetSearch: function resetSearch() {
      this.listPram = {
        page: 1,
        limit: this.$constants.page.limit[0],
        templateKey: '',
        templateName: '',
        status: null
      };
      this.handlerGetListData();
    },
    handerSearch: function handerSearch() {
      var doRefresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (doRefresh === 1) {
        this.listPram = {
          page: 1,
          limit: this.$constants.page.limit[0],
          templateKey: this.listPram.templateKey,
          templateName: this.listPram.templateName,
          status: this.listPram.status
        };
      }
      this.listPram.page = 1;
      this.handlerGetListData();
    },
    handlerGetListData: function handlerGetListData() {
      var _this = this;
      this.listLoading = true;
      sysTempApi.getSystemTemplateList(this.listPram).then(function (data) {
        _this.listData = data;
        _this.listLoading = false;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData();
    },
    handlerAdd: function handlerAdd() {
      this.$refs['EditSystemTempRef'].openInit();
    },
    handlerOpenEdit: function handlerOpenEdit(row) {
      this.$refs['EditSystemTempRef'].openInit(row);
    },
    handlerDelete: function handlerDelete(row) {
      var _this2 = this;
      this.$confirm("\u786E\u5B9A\u8981\u5220\u9664\u6A21\u677F\u3010".concat(row.templateName, "\u3011\u5417\uFF1F"), '提示', {
        type: 'warning'
      }).then(function () {
        sysTempApi.deleteSystemTemplate(row.id).then(function () {
          _this2.$message.success('删除成功');
          _this2.handerSearch(0);
        });
      }).catch(function () {});
    },
    onStatusChange: function onStatusChange(row) {
      var _this3 = this;
      sysTempApi.changeSystemTemplateStatus(row.id, row.status).then(function () {
        _this3.$message.success('状态更新成功');
      }).catch(function () {
        _this3.handerSearch(0);
      });
    },
    getChannelEnabled: function getChannelEnabled(row, channelCode) {
      if (!row.channels || !row.channels.length) return 0;
      var ch = row.channels.find(function (c) {
        return c.channelCode === channelCode;
      });
      return ch ? ch.enabled : 0;
    },
    onChannelSwitchChange: function onChannelSwitchChange(row, channelCode, enabled) {
      var _this4 = this;
      var CHANNEL_NAME = {
        feishu: '飞书',
        sms: '短信',
        wechat: '微信',
        email: '邮箱'
      };
      sysTempApi.changeSystemTemplateChannelStatus(row.id, channelCode, enabled).then(function () {
        _this4.$message.success("".concat(CHANNEL_NAME[channelCode], "\u72B6\u6001\u66F4\u65B0\u6210\u529F"));
        _this4.handerSearch(0);
      }).catch(function () {
        _this4.handerSearch(0);
      });
    }
  }
};